<template>
	<div class="home container page">
		<div class="rows">
			<row v-for="cat in data" :data="cat" :key="cat.id"></row>
			<!-- <div class="empty">
				No devices matched your search
			</div> -->
		</div>
	</div>
</template>

<script>
import data from "../data";
import row from "../components/row.vue";

export default {
	components: {row},
	data() {
		return {data};
	},
	created() {
		this.$store.page();
		this.$store.desc();
	}
};
</script>

<style lang="scss" scoped>
.home {
	margin-top: 1em;
}
.rows {
	& > div {
		// &.empty {
		// 	padding-top: 4em;
		// 	font-size: 1.2em;
		// 	text-align: center;
		// 	display: none;
		// }
		// &:only-child {
		// 	display: block;
		// }
	}
}
</style>
